import * as environment from '../environment'
import { get, getHeaders } from './common'


export async function getStats() {
    return get(
        `https://graysensepremiumfiles.blob.core.windows.net/flowsresults/result_public_stats.json`,
    );
}



export async function getMetrics() {
    const headers = getHeaders(true);

    return get(
        `${environment.default.gatewayBaseUrl}/admin/metrics`,
        headers
    );
}

